export const promotionImageButtonMapper = (data) => {
  return {
    event: 'promotion_click',
    promo_url: (data.href ? data.href : null)
  }
}
